import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import StrategicCounselForModernEnterprise from "./sections/StrategicCounselForModernEnterprise";
import TheBatonRougeServiceCircle from "./sections/TheBatonRougeServiceCircle";
import InvestmentPathways from "./sections/InvestmentPathways";
import KeyBenefits from "./sections/KeyBenefits";
import LeParcoursBoxify from "./sections/LeParcoursBoxify";
import RealStoriesFromSatisfiedUsers from "./sections/RealStoriesFromSatisfiedUsers";
import BeginYourExperience from "./sections/BeginYourExperience";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <StrategicCounselForModernEnterprise />
      <TheBatonRougeServiceCircle />
      <InvestmentPathways />
      <KeyBenefits />
      <LeParcoursBoxify />
      <RealStoriesFromSatisfiedUsers />
      <BeginYourExperience />
      <Footer />
    </div>;
}